import { Subject } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ServidorService } from '../_servicos/servidor.service';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { RestService } from '../_servicos/rest.service';

@Component({
  selector: 'app-consignado',
  templateUrl: './consignado.component.html',
  styleUrls: ['./consignado.component.scss'],
})
export class ConsignadoComponent implements OnInit {
  private readonly recurso: string = 'consignado'; //mesmo que a rota
  //carregando = false;

  //servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();

  constructor(
    private servService: ServidorService,
    public env: EnvService,
    private service: RestService
  ) {}

  ngOnInit() {
    this.atualizar();
  }

  atualizar() {
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }
  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
  }
}
